import { useBackend } from "../../services";
import { IAlbumIdentifier } from "./interfaces";

export const useReorderAlbumIdentifiers = () => {
  const { post } = useBackend();
  const reorderAlbumIdentifiers = (albumIdentifiers: IAlbumIdentifier[]) => {
    const sortedUuids = albumIdentifiers.map(albumContent => albumContent.uuid);
    return post("albumIdentifiers/reorder", { sortedUuids });
  };
  return { reorderAlbumIdentifiers };
};
